// @ts-nocheck

import { request } from '../../../../context';
import type { ApiOptions } from '../../../../context';
import type { PutTopicSettingsByIdStatusByStatusParam, BaseResponseVoid } from '../../../../types';

/**
 * 话题配置-更新状态
 *
 * @export
 * @tags 话题配置
 * @link [PUT] /topicSettings/{id}/status/{status}
 * @param id
 * @param status
 */
export function putTopicSettingsByIdStatusByStatus(
    options: ApiOptions<PutTopicSettingsByIdStatusByStatusParam, never> & {
        segments: PutTopicSettingsByIdStatusByStatusParam;
    }
): Promise<BaseResponseVoid> {
    return request<never, PutTopicSettingsByIdStatusByStatusParam, never>(
        '/topicSettings/{id}/status/{status}',
        { ...options, method: 'put', __$requestCalleeName: 'putTopicSettingsByIdStatusByStatus' }
    );
}

export const meta = [
    { tags: ['话题配置'], path: '/topicSettings/{id}/status/{status}', method: 'put' },
];
